module.exports = __webpack_public_path__ + "static/media/MyFarms.a659eb35.svg";